var $ = require('jquery');
require('jquery-match-height');
require('slick-carousel');
var map = require('./map');
var news = require('./news');

$(document).ready(function(){

	$(".js-toggle-mobile-nav").click(function(){
		$(this).find(".menu-icon").toggleClass("open");
		$(".mobile__navigation").toggleClass("open");
	});
	$(".menu-item-has-children > ,nav-link").click(function(){
		$(this).toggleClass("open").siblings("ul").toggleClass("open");
	});

	$('.homepage-banner').slick({
	    arrows: false,
	    dots: true,
	    // autoplay: true,
	    // autoplaySpeed: 5000
	});

	$('.footer-gallery--slider').slick({
	    arrows: false,
	    dots: true,
	    autoplay: true,
	    autoplaySpeed: 5000
	});

	$(".blocks-wrapper > .block").matchHeight();
	$(".item__heading").matchHeight();
	$(".item__summary").matchHeight();
	$(".profile__content").matchHeight();

	map('map');

	news();

	$(".js-open-lightbox").click(function(e){
		e.stopPropagation()
		$("body").addClass("lightbox-active");
		$(".lightbox-container").show();
	});
	$(".js-close-lightbox").click(function(e){
		$("body").removeClass("lightbox-active");
		$(".lightbox-container").hide();
	});
	$("body").click(function(e){
		if( $(".lightbox-container").is(":visible") && $(e.target).is(":not(.lightbox)") ){
			$("body").removeClass("lightbox-active");
			$(".lightbox-container").hide();
		}
	});

});